import type { ReactNode } from 'react';
import type { TrialSubscription } from './types';

interface TrialOfferSummaryProps {
  className?: string;
  note?: ReactNode;
  originalPrice: string;
  subscriptions: TrialSubscription[];
}

const TrialOfferSummary = ({ className = '', note = null, originalPrice, subscriptions }: TrialOfferSummaryProps) => (
  <div className={className}>
    <div className="fw-bold mb-2 text-1_25">
      $0.00
      <span className="ps-1 text-line-through text-heading-light">{originalPrice}</span>
    </div>
    <div className="fw-bold">Included with your trial:</div>
    <ul>
      {subscriptions.map((subscription) => (
        <li key={subscription.name}>
          {subscription.name}
          <span className="ps-1 text-line-through text-heading-light">{subscription.price}</span>
        </li>
      ))}
    </ul>
    {note && <div className="text-0_75">{note}</div>}
  </div>
);

export default TrialOfferSummary;
